export default "__VITE_ASSET__39a24411__"